export const CLEAR_DOWNLOAD_REPORT_URL = 'CLEAR_DOWNLOAD_REPORT_URL'
export const CLEAR_REPORT_EXPENSES = 'CLEAR_REPORT_EXPENSES'
export const CREATE_REPORT = 'CREATE_REPORT'
export const CREATE_REPORT_FAILED = 'CREATE_REPORT_FAILED'
export const CREATE_REPORT_SUCCEEDED = 'CREATE_REPORT_SUCCEEDED'
export const DELETE_REPORT = 'DELETE_REPORT'
export const DELETE_REPORT_FAILED = 'DELETE_REPORT_FAILED'
export const DELETE_REPORT_SUCCEEDED = 'DELETE_REPORT_SUCCEEDED'
export const FETCH_AUDIT_LOGS = 'FETCH_AUDIT_LOGS'
export const FETCH_AUDIT_LOGS_FAILED = 'FETCH_AUDIT_LOGS_FAILED'
export const FETCH_AUDIT_LOGS_SUCCEEDED = 'FETCH_AUDIT_LOGS_SUCCEEDED'
export const FETCH_REPORT_EXPENSES = 'FETCH_REPORT_EXPENSES'
export const FETCH_REPORT_EXPENSES_FAILED = 'FETCH_REPORT_EXPENSES_FAILED'
export const FETCH_REPORT_EXPENSES_SUCCEEDED = 'FETCH_REPORT_EXPENSES_SUCCEEDED'
export const FETCH_REPORTS = 'FETCH_REPORTS'
export const FETCH_REPORTS_FAILED = 'FETCH_REPORTS_FAILED'
export const FETCH_REPORTS_SUCCEEDED = 'FETCH_REPORTS_SUCCEEDED'
export const UPDATE_REPORT = 'UPDATE_REPORT'
export const UPDATE_REPORT_FAILED = 'UPDATE_REPORT_FAILED'
export const UPDATE_REPORT_SUCCEEDED = 'UPDATE_REPORT_SUCCEEDED'
export const CREATE_EXPORT_REPORT = 'CREATE_EXPORT_REPORT'
export const CREATE_EXPORT_REPORT_FAILED = 'CREATE_EXPORT_REPORT_FAILED'
export const CREATE_EXPORT_REPORT_SUCCEEDED = 'CREATE_EXPORT_REPORT_SUCCEEDED'
export const CREATE_TRANSACTION_REPORT = 'CREATE_TRANSACTION_REPORT'
export const CREATE_TRANSACTION_REPORT_FAILED = 'CREATE_TRANSACTION_REPORT_FAILED'
export const CREATE_TRANSACTION_REPORT_SUCCEEDED = 'CREATE_TRANSACTION_REPORT_SUCCEEDED'
